import React from 'react';
import { X } from 'lucide-react';
import './PremiumPopup.css';

/**
 * PremiumPopup - Reusable modal with premium gold & black theme
 * 
 * @param {boolean} isOpen - Control visibility
 * @param {function} onClose - Handler to close modal
 * @param {string} title - Modal heading
 * @param {string} message - Main message content
 * @param {string} type - 'info' | 'success' | 'error' | 'confirm'
 * @param {function} onConfirm - Handler for confirm action (if type='confirm')
 * @param {string} confirmText - Text for confirm button
 * @param {string} cancelText - Text for cancel button
 */
export default function PremiumPopup({
  isOpen,
  onClose,
  title = 'DIMAKAS',
  message,
  type = 'info',
  onConfirm,
  confirmText = 'OK',
  cancelText = 'ΑΚΥΡΩΣΗ',
}) {
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    onClose();
  };

  return (
    <div 
      className="premium-modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      data-testid="premium-popup"
    >
      <div className="premium-modal-panel">
        {/* Decorative divider */}
        <div className="premium-modal-divider" aria-hidden="true">
          <span className="premium-modal-divider-line" />
          <span className="premium-modal-divider-dot" />
          <span className="premium-modal-divider-line" />
        </div>

        {/* Close button */}
        <button 
          onClick={onClose} 
          className="premium-modal-close"
          aria-label="Close"
          data-testid="premium-popup-close"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Content */}
        <div className="premium-modal-content">
          <p className="premium-modal-eyebrow">{title}</p>
          <div className="premium-modal-message">
            {type === 'success' && <span className="premium-modal-icon">✓</span>}
            {type === 'error' && <span className="premium-modal-icon premium-modal-icon-error">✕</span>}
            <p className="premium-modal-copy">{message}</p>
          </div>
        </div>

        {/* Actions */}
        <div className="premium-modal-actions">
          {type === 'confirm' ? (
            <>
              <button 
                onClick={handleConfirm} 
                className="premium-modal-primary"
                data-testid="premium-popup-confirm"
              >
                {confirmText}
              </button>
              <button 
                onClick={onClose} 
                className="premium-modal-secondary"
                data-testid="premium-popup-cancel"
              >
                {cancelText}
              </button>
            </>
          ) : (
            <button 
              onClick={onClose} 
              className="premium-modal-primary"
              data-testid="premium-popup-ok"
            >
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
